import { createSlice } from "@reduxjs/toolkit";

export interface ConfigState {
	siteName: string;
}

const initialState: ConfigState = {
	siteName: "Student Portal",
};

const configSlice = createSlice({
	name: "config",
	initialState,
	reducers: {
		resetConfig: () => {
			return initialState;
		},
	},
});

export const { resetConfig } = configSlice.actions;
export default configSlice.reducer;
